import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Logger} from '../../util/logger';
import {StandaloneComponent} from '../standalone.component';
import {ActivatedRoute, Router} from '@angular/router';
import {ViewProfileComponent} from '../view-profile/view-profile.component';
import {AppConstants} from '../AppConstants';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {TotpService, User} from '../../gen';
import {FormIntactChecker} from '../FormIntactChecker';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CountriesService} from '../countries-service';
import {CanComponentDeactivate} from '../can-deactivate-guard.service';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {AlertHandler} from '../no-concurrent-alerts-handler';
import {cardFooterFeedbackTransition, createTabSlideTransitionSteps} from '../animations';
import {AnimationBuilder, AnimationFactory} from '@angular/animations';
import {AuthenticationInfoService} from '../authentication-info.service';

interface Item {
  value: string;
  label: string;
}
const _ = (s) => s;
@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    cardFooterFeedbackTransition,
  ],
})
export class EditProfileComponent extends ViewProfileComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  totpActive = false;
  profileForm = new FormGroup({
    personal: new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      nickname: new FormControl('', []),
      preferredUsername: new FormControl('', []),
      professionalTitle: new FormControl('', []),
    }),
    contact: new FormGroup({
      phoneNumber: new FormControl('', []),
      address: new FormGroup({
        country: new FormControl('', []),
        streetAddress: new FormControl('', []),
        locality: new FormControl('', []),
        region: new FormControl('', []),
        postalCode: new FormControl('', []),
      }),
    }),
    login: new FormGroup({
      email: new FormControl('', []),
      password: new FormControl('*************', []),
      totp: new FormControl('', []),
    }),
  });
  submitFailed: boolean;
  countryList: Item[];
  tabs: String[] = ['profile', 'contact' , 'login'];
  activeTab: String = 'profile';
  skipUnloadNotification: boolean;
  // Really don't see why fuck I need this here, no mention anywhere in the docs.
  modal: NgbModalRef;
  enabledLabel = '';
  disabledLabel = '';

  @ViewChild('tabHolder', { static: false }) tabHolder: ElementRef;
  @ViewChild('profileTab', { static: false }) profileTab: ElementRef;
  @ViewChild('loginTab', { static: false }) loginTab: ElementRef;
  @ViewChild('contactTab', { static: false }) contactTab: ElementRef;
  @ViewChild('confirmUnsavedChangesNavigation', { static: true }) confirmUnsavedChangesNavigation: ElementRef;
  private profileFormChecker: FormIntactChecker;
  private personalFormGroupChecker: FormIntactChecker;
  private contactFormGroupChecker: FormIntactChecker;
  private loginFormGroupChecker: FormIntactChecker;

  constructor(private animationBuilder: AnimationBuilder,
              authenticationInfoService: AuthenticationInfoService,
              route: ActivatedRoute,
              router: Router,
              countries: CountriesService,
              @Inject('TotpApi') private totpApi: TotpService,
              private modalService: NgbModal,
              translate: TranslateService,
              private alertHandler: AlertHandler,
              logger: Logger,
              hostElement: ElementRef
  ) {
    super(
      authenticationInfoService,
      route,
      router,
      countries,
      logger,
      translate,
      hostElement);
    this.focusSelectorPrefix = '.card-body .tab-content .active';
    this.route.fragment.subscribe(p => {
      if (p && this.tabs.indexOf(p) >= 0) {
        this.activeTab = p;
      }
    });
    this.beforeunloadHandler = this.beforeunloadHandler.bind(this);
  }
  changeTab(t: string) {
    if (t && t !== this.activeTab) {
      const oldTab = this.activeTab;
      const newTab = t;
      this.activeTab = t;
      if (!this.isIEorEDGE()) {
        let animationFactory: AnimationFactory;
        animationFactory = this.animationBuilder.build(
          createTabSlideTransitionSteps(this[oldTab + 'Tab'], this[newTab + 'Tab'], 300)
        );
        const anim: any = animationFactory.create(this.tabHolder.nativeElement);
        anim.onDone(() => {
          anim.reset();
          StandaloneComponent.setFocusToElemOrChildControl(this.hostElement, this.focusSelectorPrefix);
        });
        anim.play();
      } else {
        StandaloneComponent.setFocusToElemOrChildControl(this.hostElement, this.focusSelectorPrefix);
      }
    }
  }
  onProfileLoaded(response: User) {
    super.onProfileLoaded(response);
    if (this.profile) {
      this.resolveField('personal.firstName').setValue(this.profile.firstName || '');
      this.resolveField('personal.lastName').setValue(this.profile.lastName || '');
      this.resolveField('personal.nickname').setValue(this.profile.nickname || '');
      this.resolveField('personal.preferredUsername').setValue(this.profile.preferredUsername || '');
      this.resolveField('personal.professionalTitle').setValue(this.profile.professionalTitle || '');
      this.resolveField('login.email').setValue(this.profile.email || '');
      this.resolveField('contact.phoneNumber').setValue(this.profile.phoneNumber || '');
      if (this.profile.address) {
        this.resolveField('contact.address.country').setValue(this.profile.address.country || '');
        this.resolveField('contact.address.streetAddress').setValue(this.profile.address.streetAddress || '');
        this.resolveField('contact.address.locality').setValue(this.profile.address.locality || '');
        this.resolveField('contact.address.region').setValue(this.profile.address.region || '');
        this.resolveField('contact.address.postalCode').setValue(this.profile.address.postalCode || '');
      }
      this.profileFormChecker = new FormIntactChecker(this.profileForm);
      this.profileFormChecker.markIntact();
      this.personalFormGroupChecker = new FormIntactChecker(this.resolveField('personal') as FormGroup);
      this.personalFormGroupChecker.markIntact();
      this.contactFormGroupChecker = new FormIntactChecker(this.resolveField('contact') as FormGroup);
      this.contactFormGroupChecker.markIntact();
      this.loginFormGroupChecker = new FormIntactChecker(this.resolveField('login') as FormGroup);
      this.loginFormGroupChecker.markIntact();
    }
  }
  ngOnInit() {
    super.ngOnInit();
    this.skipUnloadNotification = false;
    this.countries.alphabetical().subscribe(res => {
      this.countryList = res.map((n) => ({label: n.name, value: n.code}));
    });
    window.addEventListener('beforeunload', this.beforeunloadHandler);
    this.translate.get(_('edit-profile.totp.enabled-label')).subscribe((res) => {
      this.enabledLabel = res;
    }, err => {
      this.enabledLabel = 'edit-profile.totp.enabled-label';
    });
    this.translate.get(_('edit-profile.totp.disabled-label')).subscribe((res) => {
      this.disabledLabel = res;
    }, err => {
      this.disabledLabel = 'edit-profile.totp.disabled-label';
    });
    this.totpApi.getTotpConfiguration('response', false).subscribe(
      response => {
        if (response && response.body) {
          this.totpActive = response.body.activated;
          this.resolveField('login.totp').setValue(this.totpActive ? this.enabledLabel : this.disabledLabel);
        }
      }, err => {
        this.totpActive = false;
        this.resolveField('login.totp').setValue(this.totpActive ? this.enabledLabel : this.disabledLabel);
      }
    );
  }
  ngOnDestroy() {
    window.removeEventListener('beforeunload', this.beforeunloadHandler);
  }

  beforeunloadHandler(e) {
    if (this.profileForm.dirty && !this.skipUnloadNotification) {
      (e || window.event).preventDefault();
      // Seems that this copy is never shown anywhere, yet required(?) for the navigation blocker to work
      (e || window.event).returnValue = this.translate.get('edit-profile.unsaved-changes-dialog.info-paragraph');
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.profileForm.dirty && !this.skipUnloadNotification) {
      this.modal = this.modalService.open(this.confirmUnsavedChangesNavigation, {ariaLabelledBy: 'modal-basic-title'});
      return this.modal
        .result
        .then((result) => {
          return result !== 'cancel';
        })
        .catch(err => {
          return false;
        })
      ;
    } else {
      return true;
    }
  }

  resolveCountryOptions(obj?: Item): Item[] {
    let t = null;
    if (this.countryList) {
      t = [].concat(this.countryList);
      if (obj) {
        t.unshift(obj);
      }
    }
    return t;
  }
  isFieldInvalid(field: string): boolean {
    return this.hasError(field) || this.isInputInvalid(field);
  }

  isInputInvalid(f: string): boolean {
    const field: AbstractControl = this.resolveField(f);
    return field.invalid && field.touched;
  }

  isFieldValid(field: string): boolean {
    return !this.hasError(field) && this.isInputValid(field);
  }

  isInputValid(f: string): boolean {
    const field: AbstractControl = this.resolveField(f);
    return field.valid && field.touched;
  }

  hasError(field?: string, code?: string): boolean {
    return !field ? this.submitFailed === true : false;
  }
  cancel() {
    this.skipUnloadNotification = true;
    this.router.navigate([AppConstants.PATH_PROFILE], {
      relativeTo: this.route,
    }).then(() => {
      this.skipUnloadNotification = false;
    }, () => {
      this.skipUnloadNotification = false;
    });
  }
  onSubmit() {
    this.skipUnloadNotification = true;
    this.submitFailed = false;
    const profileObj: User = {
      firstName: this.resolveField('personal.firstName').value,
      lastName: this.resolveField('personal.lastName').value,
      nickname: this.resolveField('personal.nickname').value,
      preferredUsername: this.resolveField('personal.preferredUsername').value,
      professionalTitle: this.resolveField('personal.professionalTitle').value,
      email: this.resolveField('login.email').value,
      phoneNumber: this.resolveField('contact.phoneNumber').value,
      address: {
        country: this.resolveField('contact.address.country').value,
        streetAddress: this.resolveField('contact.address.streetAddress').value,
        locality: this.resolveField('contact.address.locality').value,
        region: this.resolveField('contact.address.region').value,
        postalCode: this.resolveField('contact.address.postalCode').value,
      },
    };
    this.authenticationInfoService.updateUser(profileObj).subscribe(response => {
      this.router.navigate([AppConstants.PATH_PROFILE], {
        relativeTo: this.route,
      }).then(() => {
        this.skipUnloadNotification = false;
      }, () => {
        this.skipUnloadNotification = false;
      });
    }, error => {
      this.skipUnloadNotification = false;
      this.submitFailed = true;
    });
  }

  changeEmail() {
    this.router.navigate([AppConstants.PATH_PROFILE], {
      relativeTo: this.route,
    });
  }
  changePWD() {
    this.router.navigate([AppConstants.PATH_CHANGE_PASSWORD], {
      relativeTo: this.route,
    });
  }
  configureTotp() {
    this.router.navigate([AppConstants.PATH_CONFIGURE_TOTP], {
      relativeTo: this.route,
    });
  }


  private resolveField(s: string): AbstractControl {
    let retVal: AbstractControl = null;
    if (s.indexOf('.')) {
      const t = s.split('.');
      retVal = this.profileForm;
      for (let i = 0; i < t.length; i++) {
        retVal = retVal.get(t[i]);
      }
    }
    return retVal;
  }
  public resolveWindowTitlePart(): Observable<string|undefined> {
    return this.translate.get(_('edit-profile.window-title'));
  }
}
